import { SafetyPlanTestID } from "@/constants/TestID";
import SafetyPlanSection, {
  LinkText,
} from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import { joinTestIDs } from "@/utils/string.util";

interface LocalEmsPhoneSectionProps {
  localEmsPhone?: string;
  onLinkPress: (text: string) => void;
}

const LocalEmsPhoneSection = ({
  localEmsPhone,
  onLinkPress,
}: LocalEmsPhoneSectionProps) => {
  const localEMS = localEmsPhone
    ? [
        <LinkText
          key={SafetyPlanTestID.LocalEmsPhone}
          linkType="tel"
          onPress={() => {
            onLinkPress(localEmsPhone);
          }}
          testID={SafetyPlanTestID.LocalEmsPhone}
          text={localEmsPhone}
        />,
      ]
    : [];
  return (
    <SafetyPlanSection
      statements={localEMS}
      testID={joinTestIDs(SafetyPlanTestID.LocalEmsPhone, "section")}
      title="Local EMS"
    />
  );
};

export default LocalEmsPhoneSection;
